import http from "@/util/http.js"
const PREFIX = "/user"

export default {
    async info(customConfig)
    {
        return await http.get(PREFIX + '/info', {customConfig})
    },
    async infoUpdate(customConfig)
    {
        return await http.get(PREFIX + '/info/update', {customConfig})
    },
    async updateUser(user, customConfig)
    {
        return await http.post(PREFIX + '/info/update', user, {customConfig})
    },
    async empresa(text, customConfig)
    {
        return await http.get(PREFIX + '/empresa', { params: { text }, customConfig})
    },
    async contrato(customConfig)
    {
        return await http.get(PREFIX +  "/empresa/contrato", { customConfig })
    },
    async getEmailHint(cpf, customConfig)
    {
        return await http.get(PREFIX + '/email-hint', { params: {cpf}, customConfig })
    },
    async getPhoneHint(cpf, customConfig)
    {
        return await http.get(PREFIX + '/phone-hint', { params: {cpf}, customConfig })
    },
    async askRedefinePassword(cpf, email, customConfig)
    {
        return await http.post(PREFIX + '/password/ask-redefine', { cpf, email }, {customConfig})
    },
    async validateToken(token, customConfig)
    {
        return await http.get(PREFIX + '/password/validate-token', { params: { token }, customConfig })
    },
    async redefinePassword(token, password, customConfig)
    {
        return await http.post(PREFIX + '/password/redefine', { token, password }, {customConfig})
    },
    async get(userId, customConfig)
    {
        return await http.get(PREFIX + "/" + userId, {customConfig})
    },
    async save(user, customConfig)
    {
        return await http.post(PREFIX, user, {customConfig})
    },
    async edit(userId, user, customConfig)
    {
        return await http.put(PREFIX + "/" + userId , user, {customConfig})
    },
    async delete(userId, customConfig)
    {
        return await http.delete(PREFIX + "/" + userId, {customConfig})
    },
    async filter(filter, page = 1, customConfig)
    {
        return await http.post(PREFIX + "/filter?page=" + page, filter, {customConfig})
    },
    async listPerfis(userId, customConfig)
    {
        return await http.get(PREFIX + "/" + userId + "/profiles", {customConfig})
    },
    async savePerfis(userId, permissoes, customConfig)
    {
        return await http.post(PREFIX + "/" + userId + "/profiles", permissoes, {customConfig})
    }
  }